import Request from '../data/request'

export default class ApiFinder {

    static tasks(projectId: ID, openOnly: boolean) {
        return new Request(this,'GET','finder/task/{0}/{1}'.f(projectId, (openOnly ? 'open' : 'all')),{})
    }

    static notes(projectId: ID) {
        return new Request(this,'GET','finder/note/{0}'.f(projectId),{})
    }

    static events(projectId: ID, openOnly: boolean) {
        return new Request(this,'GET','finder/events/{0}/{1}'.f(projectId, (openOnly ? 'open' : 'all')),{})
    }
}